import create from './create';
import update from './update';
import devicesGroups from './devices-groups';

export default {
  create,
  update,
  devicesGroups,
};
